import React, { useEffect } from "react";
import { Container, Button } from "react-bootstrap";
import "./KYC_Verified.css";
import CommonBreadcrumb from "./../../common_components/breadcrumb/CommonBreadcrumb";
import WhiteButton from "./../../common_components/common_button/WhiteButton";
import { useNavigate } from "react-router-dom";
import Succes_lottie from "./../../animation/succes_lottie/Succes_lottie";
import Login_Succes_Lottie from "./../../animation/login_succes_lottie/Login_Succes_Lottie";

const KycSuccess = () => {
  const navigate = useNavigate();
  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Wallet & Earnings" },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/profile");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <section className="kyc-verified-section">
      <CommonBreadcrumb items={breadcrumbItems} />
      <Container className="kyc-wrapper text-center">
        {/* Card */}
        <div className="kyc-card ">
          <Login_Succes_Lottie />
          <div className="text-area">
            <h4 className="kyc-title">KYC Details Submitted Successfully</h4>
            <p className="kyc-text">
              KYC details submitted successfully. Your account is under
              verification. You will be notified once verified.
            </p>
          </div>
        </div>

        {/* Button */}
        {/* <WhiteButton
          title={"Withdraw Earnings"}
          bg="#000"
          color="#f35f37"
          hoverColor="#f35f37"
          hoverBg={"#000"}
          onClick={() => navigate("/withdraw")}
        /> */}
      </Container>
    </section>
  );
};

export default KycSuccess;
